import { Alert, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil';
import { MerSETASDIService } from '../../../../../Component/Api/merSETA/Internal/MerSETASDIService';
import { MerSETALAIService } from '../../../../../Component/Api/merSETA/LAI/MerSETALAIService';
import { ConfirmationDialog } from '../../../../../Component/Common/Components/ConfirmationDialog';
import { DataTable } from '../../../../../Component/Common/Components/DataTable/DataTable';
import { FilterType, IFilter } from '../../../../../Component/Common/Components/DataTable/Filters';
import { ColumnSortOption } from '../../../../../Component/Model/Dto/ColumnSortOption';
import { filterColumnValues } from '../../../../../Component/Model/Dto/ScorecardLicense';
import { MerSetaSdiSearchDto, MersetaSdiSearchRequest } from '../../../../../Component/Model/Dto/WSP/MerSETASDI';
import { EntriesPerPage } from '../../../../../Component/Model/Table/Table';
import { defaultObject, isEmptyString } from '../../../../../Helpers/typescriptHelper';
import { OrganisationAtom } from '../../../../../State/Organisation.Atom';
import { OrganisationSDITrainingDataTable } from './OrganisationInternalTrainingDataTable';
import { InterventionAtom } from '../Intervention.Atom';
import { TrainingImportButtons } from '../Import/TrainingImportButtons';
import { DataImportType } from '../../../../../Component/Model/Enum/BEE123Enums';

export const OrganisationInternalTraining = () => {
    const history = useHistory();
    const peopleAndTrainingOrganisation = useRecoilValue(OrganisationAtom);
    const [platformTrainingData, setPlatformTrainingData] = useState<MerSetaSdiSearchDto[]>([]);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 25 });
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
    const [filteredItemCount, setFilteredItemCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [interventionTypeId, setInterventionTypeId] = useState<number[]>();
    const [interventionTitleId, setInterventionTitleId] = useState<number[]>();
    const [beeCategoryId, setBeeCategoryId] = useState<number[]>();
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
    const [hasNoSeta, setHasNoSeta] = useState<boolean>(false);
    const [interventionTitle, setInterventionTitle] = useState<filterColumnValues[]>(defaultObject);
    const [interventionType, setInterventionType] = useState<filterColumnValues[]>(defaultObject);
    const [beeCategory, setBeeCategory] = useState<filterColumnValues[]>(defaultObject);
    const [searchValue, setSearchValue] = useState<string>('');
    const [merSetaSdiId, setMerSetaSdiId] = useState<number>(0);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption>(defaultObject);
    const [selectedCourseName, setSelectedCourseName] = useState<string>();
    const confirmDeleteMessage = `Are you sure you want to delete the course ${selectedCourseName}?`;

    const setSelectedSDI = useRecoilCallback(({ set }) => (id: number) => {
        set(InterventionAtom, { id });
    });

    const trainingPeopleFilters: Array<IFilter> = [
        {
            label: 'Date',
            values: [],
            type: FilterType.dateRange, propname: 'startEndDate',
        },
        {
            label: 'BEE Categories:',
            values: beeCategory,
            type: FilterType.multiselect, propname: 'beeCategory'
        },
        {
            label: 'Intervention Type:',
            values: interventionType,
            type: FilterType.multiselect, propname: 'interventionTypeId'
        },
        {
            label: 'Intervention Title:',
            values: interventionTitle,
            type: FilterType.multiselect, propname: 'interventionTitleId'
        }
    ]
    useEffect(() => {
        if (peopleAndTrainingOrganisation.OrganisationId > 0) {
            SearchTraining();
            if ((peopleAndTrainingOrganisation.SetaTypeId !== "0" || isEmptyString(peopleAndTrainingOrganisation.SetaTypeId))) {
                setHasNoSeta(true);
            }
        }
    }, [
        peopleAndTrainingOrganisation,
        entriesPerPage,
        pageNumber,
        interventionTypeId,
        beeCategoryId,
        columnSortOptions,
        startDate,
        endDate,
        interventionTitleId,
        searchValue
    ]);

    useEffect(() => {
        fetchStaticData();
    }, [])

    useEffect(() => {
        setSelectedSDI(-1);
    }, [])

    const fetchStaticData = async () => {
        try {
            const resultTitlesPromise = await MerSETALAIService.GetMerSETAInterventionTitles();
            const resultCatgoriesPromise = await MerSETASDIService.GetMerSETACategoryInterventions();

            const [interventionTitle, beeCategories] = await Promise.all([
                resultTitlesPromise,
                resultCatgoriesPromise,
            ])

            const interventionTitleData: filterColumnValues[] = interventionTitle.data.map((data) => {
                return { key: data.description, val: data.code };
            })

            const beeCategoriesData: filterColumnValues[] = beeCategories.data.map((data) => {
                return { key: data.category, val: data.id };
            })

            const interventionTypeData: filterColumnValues[] = beeCategories.data.map((data) => {
                return data.interventionTypes.map(intervention => {
                    return { key: intervention.description, val: intervention.code }
                });
            }).flat();

            setInterventionTitle(interventionTitleData);
            setBeeCategory(beeCategoriesData);
            setInterventionType(interventionTypeData);


        } catch (error) {
            console.error(error);
        }
    }



    const organisationAndTrainingSearchRequest: MersetaSdiSearchRequest = {
        organisationId: peopleAndTrainingOrganisation.OrganisationId,
        searchValue: searchValue,
        columnSortOptions: [],
        interventionTitleId: interventionTitleId,
        interventionTypeId: interventionTypeId,
        beeCategoryId: beeCategoryId,
        startDate: startDate,
        endDate: endDate,
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        ColumnName: columnSortOptions.ColumnName,
        SortDirection: columnSortOptions.SortDirection
    }

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    };

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    };


    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions(sortOption)
        setPageNumber(1);
    };

    const filtersChanged = async (filterProps: any) => {
        const { start, end } = filterProps['startEndDate'] || { start: null, end: null };
        const interventionTypeId = filterProps['interventionTypeId'] || null;
        const interventionTitleId = filterProps['interventionTitleId'] || null;
        const beeCategory = filterProps['beeCategory'] || null;

        const startDate = start ? new Date(start) : undefined;
        const endDate = end ? new Date(end) : undefined;

        setInterventionTypeId(interventionTypeId);
        setInterventionTitleId(interventionTitleId);
        setBeeCategoryId(beeCategory);
        setStartDate(startDate);
        setEndDate(endDate)
        setPageNumber(1);
    };

    const SearchTraining = async () => {
        setIsLoading(true);
        try {
            const result = await MerSETASDIService.SearchMerSetaSDIs(organisationAndTrainingSearchRequest);
            setPlatformTrainingData(result.data.results);
            setTotalItemsCount(result.data.totalItemsCount);
            setFilteredItemCount(result.data.filteredItemsCount);

        } catch (error) {
            console.error(error);
            setTotalItemsCount(1);
        } finally {
            setIsLoading(false);
        }
    }

    const editMerSetaSdi = (id: number) => {
        setSelectedSDI(id);
        history.push(`/organisation/training/Internal/form/Details`);
    }


    const CreateMerSetaSdi = () => {
        setSelectedSDI(-1);
        history.push(`/organisation/training/Internal/form/Details`);
    }

    const showDeleteConfirmation = (id: number, course: string) => {
        setMerSetaSdiId(id);
        setSelectedCourseName(course);
        setShowConfirmationDialog(true);
    }
    const handleDelete = async () => {
        try {
            if (merSetaSdiId) {
                await MerSETASDIService.DeleteMerSETASDI(merSetaSdiId);
                toast.success(`Successfully deleted MerSETA Internal Entry`)
            }
        } catch (error) {
            console.error(error)
        } finally {
            handleCloseConfirmation();
        }
    }

    const handleCloseConfirmation = () => {
        setShowConfirmationDialog(false);
        SearchTraining();
    }

    const handleRouteToTrainerClick = (id: number) => {
        setSelectedSDI(id);
        history.push(`/organisation/training/Internal/form/Trainers`);
    }

    const handleRouteToAttendeeClick = (id: number) => {
        setSelectedSDI(id);
        history.push(`/organisation/training/Internal/form/Attendees`);
    }

    const organisationAndTrainingTableData = OrganisationSDITrainingDataTable(platformTrainingData, editMerSetaSdi, showDeleteConfirmation, handleRouteToTrainerClick, handleRouteToAttendeeClick);
    return (
        <>
            {hasNoSeta ?
                <>
                    <Button color="primary" variant="contained" onClick={() => { CreateMerSetaSdi() }} >CAPTURE INTERNAL TRAINING</Button>
                    <DataTable
                        table={organisationAndTrainingTableData}
                        entriesPerPage={entriesPerPage}
                        pageNumber={pageNumber}
                        filters={trainingPeopleFilters}
                        filtersChanged={filtersChanged}
                        filteredItemsCount={filteredItemCount}
                        totalItemsCount={totalItemsCount}
                        entriesPerPageChanged={entriesPerPageChanged}
                        pageNumberChanged={pageNumberChanged}
                        isLoading={isLoading}
                        canSearch={true}
                        searchValueChanged={searchValueChanged}
                        manualSorting={true}
                        columnSortingChanged={columnSortingChanged}
                        searchBoxText='Search course name...'
                    ></DataTable>
                    <TrainingImportButtons dataImportType={DataImportType.MerSetaTraining} organisationId={peopleAndTrainingOrganisation.OrganisationId} fetchData={SearchTraining}/>

                    <ConfirmationDialog
                        showDialog={showConfirmationDialog}
                        handleAccept={handleDelete}
                        handleCancel={handleCloseConfirmation}
                        heading={"Confirm Delete"}
                        message={confirmDeleteMessage}
                    />
                </>
                :
                <>
                    <Alert severity="warning" style={{ paddingTop: 5 }}>
                        In order to capture accurate training data in alignment with your SETA, please request your administrator to capture a SETA on an organisation.
                    </Alert>
                </>
            }

        </>
    )
}

